import { useState } from "react";
import { SearchInputRoot } from "./SearchInput.styles";
import { useDebounce } from "@commonlibs";
import { usePartnerFindAllInfinity } from "features/partners/hooks/usePartnerFindAllInfinity";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import { PartnerDto } from "common/models";
import { PartnerType } from "ui/partners/types/PartnerType";
import useTranslate from "ui/locale/hooks/useTranslate";

export default function SearchInput() {
    const navigate = useNavigate();
    const translate = useTranslate();
    const [search, setSearch] = useState("");
    const { value, handleChange, debouncing } = useDebounce<string>("", { callback: setSearch });

    const { data: { pages = [] } = {}, isFetching } = usePartnerFindAllInfinity({ query: value });

    function onClickOption({ name, banner, ...rest }: PartnerDto) {
        navigate(MainRoutes.PARTNER_DETAILS, { state: { partner: { name, banner, ...rest } } });
    }

    function setOptionLabel(partner: PartnerDto): string {
        if (partner.type === PartnerType.ONLINE_STORE) {
            return `${partner.name} (${translate("onlineStoreSingular").toLowerCase()})`;
        }
        return partner.name;
    }

    return (
        <SearchInputRoot
            defaultValue={search}
            search={value}
            isLoading={isFetching || debouncing}
            placeholder={translate("globalSearchPlaceholder")}
            onSearchChange={handleChange}
            options={pages[0]?.items?.map((item) => ({ value: item, label: setOptionLabel(item) }))}
            onChange={(e) => onClickOption(e as PartnerDto)}
        />
    );
}
